import React from 'react'
import dayjs from 'dayjs'
import { withTranslation } from 'react-i18next'
import images from 'assets/img'
import LinkItem from 'components/Link'
import AuthMarketingPanel from './AuthMarketingPanel'

export default withTranslation()(function AuthLayout({ t, children }) {
  return (
    <div className="h-screen w-full flex bg-white overflow-hidden">
      <div className="w-full lg:w-[46%] h-full overflow-y-auto flex flex-col scrollbar-thin">
        <div className="px-6 sm:px-14 pt-8">
          <img src={images.Logo} alt="reachafrika" className="w-36" />
        </div>

        <div className="flex-1 flex flex-col justify-center px-6 sm:px-14 py-6">
          <div className="w-full max-w-md mx-auto">
            {children}
          </div>
        </div>

        <div className="px-6 sm:px-14 pb-6 flex items-center justify-between text-xs">
          <LinkItem url="/forgot-password"
            tag={() => <span className="text-secondary font-medium">{t('registration.tc')}</span>} />
          <span className="text-secondary font-medium">&copy; {dayjs().format('YYYY')} ReachAfrika LLC</span>
        </div>
      </div>

      <div className="hidden lg:block lg:w-[54%] h-full">
        <AuthMarketingPanel />
      </div>
    </div>
  )
})
